import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const forYou = ['Mujeres activas que sienten que su mente no se detiene al acostarse.', 'Deportistas que sufren de calambres o tensión muscular post-entrenamiento.', 'Personas que despiertan cansadas a pesar de haber "dormido" 8 horas.', 'Quienes buscan una solución natural, científica y sin efectos secundarios.'];
const notForYou = ['Personas que buscan una "pastilla mágica" para ignorar hábitos destructivos.', 'Quienes no están dispuestos a dedicar 10 minutos a su higiene de sueño.', 'Quienes prefieren soluciones farmacológicas pesadas.'];
export function WhoIsItFor() {
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6" data-id="element-178">
      <div className="max-w-5xl mx-auto" data-id="element-179">
        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-12 text-center" data-id="element-180">
          ¿Es para <span className="text-[#4ECDC4]" data-id="element-181">ti</span>?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-182">
          {/* For */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="glass-card rounded-2xl p-8" style={{
          borderColor: 'rgba(78, 205, 196, 0.2)'
        }} data-id="element-183">
            <h3 className="text-[#4ECDC4] font-semibold text-xl mb-6" data-id="element-184">
              Esto es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-185">
              {forYou.map((item, i) => <li key={i} className="flex gap-3" data-id="element-186">
                  <CheckCircleIcon className="w-5 h-5 text-[#4ECDC4] flex-shrink-0 mt-0.5" data-id="element-187" />
                  <span className="text-gray-300 text-sm leading-relaxed" data-id="element-188">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not for */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="glass-card rounded-2xl p-8" style={{
          borderColor: 'rgba(239, 68, 68, 0.15)'
        }} data-id="element-189">
            <h3 className="text-red-400 font-semibold text-xl mb-6" data-id="element-190">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-191">
              {notForYou.map((item, i) => <li key={i} className="flex gap-3" data-id="element-192">
                  <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-193" />
                  <span className="text-gray-300 text-sm leading-relaxed" data-id="element-194">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </AnimatedSection>;
}